import React, { useMemo } from 'react';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  SingleValueProps,
} from 'react-select';
import getWidgetIconSource from 'routes/Home/utils/getWidgetIconSource';
import { AttachmentWithIntendedUse } from 'routes/Home/utils/findAttachmentByIntendedUse';
import selectStyles from '@lib/components/Select/Select.module.scss';
import WidgetIconRenderer from './WidgetIconRenderer';
import styles from './WidgetOption.module.scss';

interface WidgetSingleValueData {
  kind?: string;
  icon?: string;
  attachmentsAttached?: AttachmentWithIntendedUse[];
  fields?: {
    link?: string;
  };
}

interface SelectPropsWithDisabled {
  disabled?: boolean;
}

function WidgetSingleValue({ children, ...restProps }: SingleValueProps) {
  const widgetData = (restProps.data as { data?: WidgetSingleValueData })?.data;
  const disabled =
    (restProps.selectProps as SelectPropsWithDisabled)?.disabled ?? false;

  const kind = widgetData?.kind ?? '';
  const icon = widgetData?.icon;
  const attachmentsAttached = widgetData?.attachmentsAttached;
  const link = widgetData?.fields?.link;

  const iconSource = useMemo(
    () =>
      getWidgetIconSource({
        kind,
        attachmentsAttached,
        link,
        materialIcon: icon,
      }),
    [kind, attachmentsAttached, link, icon],
  );

  const hasIcon = iconSource.type !== 'material' || iconSource.icon;

  return (
    <DefaultSelectComponents.SingleValue
      {...restProps}
      className={classNames({
        [selectStyles.singleValueWithIcon]: hasIcon,
      })}
    >
      {hasIcon && (
        <span
          className={classNames(
            selectStyles.optionCheckbox,
            styles.widgetSingleValueIcon,
            { [styles.widgetSingleValueIconDisabled]: disabled },
          )}
        >
          <WidgetIconRenderer
            iconSource={iconSource}
            imageClassName={styles.widgetSingleValueImage}
            faviconClassName={styles.widgetSingleValueFavicon}
            showFallback={false}
          />
        </span>
      )}
      <span className={selectStyles.singleValueChild}>{children}</span>
    </DefaultSelectComponents.SingleValue>
  );
}

export default WidgetSingleValue;
